// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"GalleryPhotoPagination-style__wrapper__b1e35aa7","pagination":"GalleryPhotoPagination-style__pagination__b1e35aa7"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/gallery/components/GalleryPhotoPagination-style.scss
// module id = 1041
// module chunks = 7 23 26 27